module.exports = __webpack_public_path__ + "media/images/ic-index-company-9fb2d73eaee0dc07cc3a6442a4d67190.svg";